import config from '../config';
// ==============================|| CONFIG - HOOKS  ||============================== //

const useConfig = () => config;

export default useConfig;
